module.exports = __webpack_public_path__ + "img/z1.3afd2a3c.png";